import client from '../client'

export const getAvailableMembershipsKey = `${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/Members/GetAvailableBenefitsPrograms`

export async function getAvailableMemberships() {
  return client(getAvailableMembershipsKey)
}
